const FAQ = [
  {
    title: 'Is it fully on-chain?',
    content: 'Yes! All the game logic and states are on-chain, so it is an entirely fair game.'
  },
  {
    title: 'Will you issue tokens?',
    content: 'We will use $LORDS as the main currency. When the time is right, we may consider issuing our own currency.'
  },
  {
    title: 'On what chains will you launch the game?',
    content: 'The current version is on Mississippi Testnet. We are also developing our Starknet version.'
  },
];

export default FAQ;